"use strict";

var novicell = novicell || {};

novicell.video = novicell.video || new function () {

  this.init = function () {
    let objectFitNotExists = Modernizr.objectfit;
    let videos = document.querySelectorAll('.js-video-spot');
    // Check if video can be opend inline on page
    if (videos && videos.length > 0) {
      for (let i = 0; i < videos.length; i++) {
        if (!objectFitNotExists) {
          let container = videos[i].querySelector('.video__figure');
          let imageUrl = container.querySelector('img').getAttribute('data-src');
          if (imageUrl) {
            container.style.backgroundImage = 'url('+imageUrl+')';
            container.classList.add('compat-object-fit');
          }
        }
      }
    }
  };
}();